import { CommonModule } from '@angular/common';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { linerSeoData } from '../../tools/constant';
import { ConsentService } from '../../consent/consent.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  standalone: true,
  imports: [CommonModule,RouterLink]
})
export class FooterComponent implements OnInit {
  
  showLinerSection: boolean = true;
  linerSeoData: any = linerSeoData
  showSubtabs: any = {};
  showFooter: any = true;
  tabName: string = '';
  footerList: any = [
    // {
    //   title: 'Services', name: 'service', subtab: [
    //     { name: 'Ocean Freight', route: '/services/ocean-freight-shipping' },
    //     { name: 'Customs Clearance', route: '/services/custom-clearance-services' },
    //     { name: 'ISF', route: '/services/importer-security-filing' },
    //     { name: 'Cargo Insurance', route: '/services/freight-cargo-insurance' }
    //   ]
    // },
    {
      title: 'Services',
      name: 'service',
      subtab: [
        {
          section: 'Primary',
          items: [
            { name: 'Ocean Freight', route: '/services/ocean-freight-shipping' },
            // Note: I left the routes exactly as you provided them, but you may want to update the URLs for Air and Trucking later!
            { name: 'Air Freight', route: '/services/air-freight' },
            { name: 'Trucking & Warehousing', route: '/services/trucking-and-warehousing' }
          ]
        },
        {
          section: 'Additional',
          items: [
            { name: 'ISF Filing', route: '/services/importer-security-filing' },
            { name: 'Customs Clearance', route: '/services/custom-clearance-services' },
            { name: 'Cargo Insurance', route: '/services/freight-cargo-insurance' }
          ]
        }
      ]
    },
    {
      title: 'Tools', name: 'tools',
      subtab: [
        { name: 'Rate Search', route: '/tools/ocean-freight-rates' },
        { name: 'Vessel Schedule', route: '/tools/vessel-schedules' },
        { name: 'Container Tracking', route: '/tools/tracking-container' },
        { name: 'Air Cargo Tracking', route: '/air-cargo-tracking' },
        { name: 'Freight Calculators', route: '/tools/cbm-calculator' },
        { name: 'Tariff Simulator', route: '/tariff-simulator' },
        { name: 'Tariff Comparison', route: '/tariff-comparison' },
        { name: 'India–USA Guides', route: '/guides' },
        { name: 'US Tariffs on India', route: '/us-tariffs' },
        { name: 'Shipping Glossary', route: '/glossary' },
        { name: 'Ports We Ship From', route: '/ship-from' },
        { name: 'Anti-Dumping Duties: India', route: '/anti-dumping/india' },
        { name: 'US Port Codes', route: '/us-port-codes' },
        { name: 'Airport Codes', route: '/airport-codes' },
        { name: 'US Imports from India', route: '/export-to-usa' },
        { name: 'India to USA Shipping', route: '/ship-to' },
        { name: 'India–USA Sealanes', route: '/india-usa-sealanes' },
        { name: 'Carriers India–USA', route: '/carriers' },
        { name: 'Indian Port Codes', route: '/india-port-codes' },
        { name: 'Chennai Office', route: '/freight-forwarder-chennai' },
        { name: 'India to USA Forwarding', route: '/freight-forwarder-india-to-usa' },
        { name: 'US Freight Forwarder', route: '/freight-forwarder-usa' },
      ]
    },
    {
      title: 'Information', name: 'info',
      subtab: [
        { name: 'Terms & Conditions', route: '/legal/terms-of-service' },
        { name: 'Privacy Policy', route: '/legal/privacy-policy' },
        { name: 'Sitemap', route: '/sitemap.xml', external: true },
      ]
    },
  ];
  filteredLinerSeoData: any[] = [];

  constructor(private route: Router, private apiService: ApiService, public consentService: ConsentService,
    private router: ActivatedRoute, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.updateLinerList(this.route.url);
    this.checkRoute(this.route.url);

    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkRoute(event.urlAfterRedirects);
        this.updateLinerList(event.urlAfterRedirects);
        // this.addSchemaForUrl(event.urlAfterRedirects);
      }
    });
  }

  updateLinerList(url: string): void {
    if (this.route.url.includes('/port-to-port/')) {
      const currentLiner = this.route.url.split('/port-to-port/')[1];

      this.filteredLinerSeoData = Object.keys(this.linerSeoData)
        .filter(key => key !== currentLiner)
        .map(key => ({
          key,
          value: this.linerSeoData[key]
        }));
    } else {
      this.filteredLinerSeoData = Object.keys(this.linerSeoData)
        .map(key => ({
          key,
          value: this.linerSeoData[key]
        }));
    }
  }

  // addSchemaForUrl(url: string) {
  //   // Remove any existing schema scripts
  //   const existingScripts = document.querySelectorAll(
  //     'script[type="application/ld+json"]'
  //   );
  //   existingScripts.forEach((script) => script.remove());

  //   // Check if the URL matches any schemas
  //   const cleanUrl = url.split('#')[0];
  //   if (this.schemas[cleanUrl]) {
  //     const schemas = this.schemas[cleanUrl];

  //     schemas.forEach((schema: any) => {
  //       const script = this.renderer.createElement('script');
  //       script.type = 'application/ld+json';
  //       script.text = JSON.stringify(schema);
  //       this.renderer.appendChild(document.head, script);
  //     });
  //   }
  // }

  checkRoute(url: string): void {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const hiddenRoutes = ['/main/discovery-rates'];
    this.showFooter = !hiddenRoutes.some(route => url.includes(route));

    // A. EXACT matches (Perfect for the Home page)
    const exactHiddenLinerRoutes = ['/', '', '/main/home']; // Added '/main/home' just in case based on your commented code
    const isExactMatch = exactHiddenLinerRoutes.includes(cleanUrl);

    // B. PARTIAL matches (Perfect for base paths like '/discovery')
    const partialHiddenLinerRoutes = ['/discovery'];
    const isPartialMatch = partialHiddenLinerRoutes.some(route => cleanUrl.includes(route));

    // C. DYNAMIC matches (Perfect for hiding on IDs but showing on the base page)
    const dynamicHiddenLinerRoutes = ['/tools/tracking-container/'];
    const isDynamicMatch = dynamicHiddenLinerRoutes.some(route => 
      cleanUrl.startsWith(route) && cleanUrl.length > route.length
    );

    // If ANY of the three checks above are true, hide the liner section
    this.showLinerSection = !(isExactMatch || isPartialMatch || isDynamicMatch);
  }

  routePage(list?: any) {
    const route = list.route;
    if (route) {
      this.apiService.setRoute(route);
      // Only the /tools search tabs have a #rate-field section to jump to. Other pages (calculators, tariff,
      // services, legal) navigate without the fragment so the navbar's scroll-to-top runs instead of leaving them at the bottom.
      if (!['/tools/ocean-freight-rates', '/tools/vessel-schedules', '/tools/tracking-container'].includes(route)) {
        this.route.navigate([route]);
        return;
      }
      this.route.navigate([route], { fragment: 'rate-field' }).then(() => {
        history.replaceState(null, '', this.route.url.split('#')[0]);
        setTimeout(() => {
          this.apiService.scrollToSection('rate-field');
        }, 10);
      });
    }
  }

  // routeToHome() {
  //   window.open('main/home', "_self");
  //   this.route.navigate(['/main/home']); //this is also work as same
  // }

  routeTo(type) {
    this.apiService.setRoute(type);
    this.route.navigate(['/']);
  }

  toggleSubtabs(i: any): void {
    this.showSubtabs[i] = !this.showSubtabs[i];
  }

  /** Footer "Do not sell or share": opens the cookie preferences dialog. */
  openPrivacyChoices() {
    this.consentService.requestPreferences();
  }

  composeEmail(value: any) {
    let body = {
      email: value
    }
    this.apiService.composeEmail(body);
  }

  openSupport() {
    let url = "https://wa.me/918925962778?text=Hi Atmavaan,%0a";
    window.open(url, '_blank');
  }

  openTwitter() {
    let url = "https://x.com/Atmavaan196054";
    window.open(url, '_blank');
  }

  openLinkedin() {
    let url = "https://www.linkedin.com/company/atmavaan";
    window.open(url, '_blank');
  }

  openInsta() {
    let url = "https://www.instagram.com/atmavaanlpl/";
    window.open(url, '_blank');
  }

}